import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useDeleteQuestion = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  const deleteQuestion = async (id: string) => {
    try {
      const { data } = await axios.delete(`/api/questions/${id}`);
      return data;
    } catch (error) {
      throw new Error(t("messages.error.deleteQuestion"));
    }
  };

  return useMutation({
    mutationFn: deleteQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["questions"] });
      message.success(t("messages.success.deleteQuestion"));
    },
  });
};
